import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import InformationCircle from '@/components/icons/InformationCircle';
import EColorPicker from '@/components/everridge/EColorPicker';
import { FormInputProps } from '@/@types/form.types';

type Props<T extends {}> = {
	isMobile?: boolean;
} & FormInputProps<T>;

const TenantColorPicker = <T extends {}>({
	control,
	fieldName,
	label,
	placeholder = 'e.g. #000000',
	isMobile,
}: Props<T>) => {
	const { t } = useTranslation();

	return (
		<div className='w-full flex flex-col gap-1.5 select-none'>
			<h4 className='text-sm font-medium'>{label}</h4>
			<Controller
				name={fieldName}
				control={control}
				render={({
					field: { value, onChange, onBlur },
					fieldState,
					formState,
				}) => {
					return (
						<>
							<div className='flex gap-2'>
								<div className='relative w-full'>
									<input
										value={value ?? ''}
										onChange={onChange}
										onBlur={onBlur}
										disabled={formState.disabled}
										placeholder={placeholder}
										className={cn(
											'w-full p-3.5 pr-11 border border-popover-100 rounded-semi-xl text-xs text-popover-800 bg-popover-10 focus:outline-hidden focus:border focus:border-popover-1000 placeholder:text-popover-600 disabled:bg-popover-50 transition-colors duration-150',
											fieldState.invalid
												? 'border-error-1000'
												: '',
										)}
									/>
									<EColorPicker
										value={value ?? ''}
										onChange={onChange}
									/>
								</div>
							</div>
							{fieldState.invalid && (
								<div className='flex items-center gap-1.5'>
									<InformationCircle className='size-4 stroke-error-1000' />
									<span className='text-xs text-error-1000'>
										{fieldState.error?.message}
									</span>
								</div>
							)}
						</>
					);
				}}
			/>
		</div>
	);
};

export default TenantColorPicker;
